export default __webpack_public_path__ + "static/media/icon4.9d0ad4c7.svg";